import { EventPhase } from "./EventsPhaseEnum";

export enum EventStatusFilter {
  ALL = 0,

  // Test
  TEST_INACTIVE = 1,
  TEST_IN_PROGRESS = 2,
  TEST_FINISHED = 3,
  TEST_ABANDONED = 4,

  // Grading
  GRADING_ALL = 5,
  GRADING_IN_PROGRESS = 6,
  GRADING_MERGED = 7,
  GRADING_ACCEPTED = 8,

  // Interview
  INTERVIEW_ALL = 9,
  INTERVIEW_IN_PROGRESS = 10,
  INTERVIEW_COMPLETED = 11,
  INTERVIEW_ACCEPTED = 12,
  INTERVIEW_ABANDONED = 13,
}

export const EVENT_STATUS_LABELS: Record<EventStatusFilter, string> = {
  [EventStatusFilter.ALL]: "All",

  [EventStatusFilter.TEST_INACTIVE]: "Test - Inactive",
  [EventStatusFilter.TEST_IN_PROGRESS]: "Test - In Progress",
  [EventStatusFilter.TEST_FINISHED]: "Test - Finished",
  [EventStatusFilter.TEST_ABANDONED]: "Test - Abandoned",

  [EventStatusFilter.GRADING_ALL]: "Grading - All",
  [EventStatusFilter.GRADING_IN_PROGRESS]: "Grading - In Progress",
  [EventStatusFilter.GRADING_MERGED]: "Grading - Merged",
  [EventStatusFilter.GRADING_ACCEPTED]: "Grading - Accepted",

  [EventStatusFilter.INTERVIEW_ALL]: "Interview - All",
  [EventStatusFilter.INTERVIEW_IN_PROGRESS]: "Interview - In Progress",
  [EventStatusFilter.INTERVIEW_COMPLETED]: "Interview - Completed",
  [EventStatusFilter.INTERVIEW_ACCEPTED]: "Interview - Accepted",
  [EventStatusFilter.INTERVIEW_ABANDONED]: "Interview - Abandoned",
};

export const TEST_STATUSES = [
  EventStatusFilter.TEST_INACTIVE,
  EventStatusFilter.TEST_IN_PROGRESS,
  EventStatusFilter.TEST_FINISHED,
  EventStatusFilter.TEST_ABANDONED,
];

export const GRADING_STATUSES = [
  EventStatusFilter.GRADING_ALL,
  EventStatusFilter.GRADING_IN_PROGRESS,
  EventStatusFilter.GRADING_MERGED,
  EventStatusFilter.GRADING_ACCEPTED,
];

export const INTERVIEW_STATUSES = [
  EventStatusFilter.INTERVIEW_ALL,
  EventStatusFilter.INTERVIEW_IN_PROGRESS,
  EventStatusFilter.INTERVIEW_COMPLETED,
  EventStatusFilter.INTERVIEW_ACCEPTED,
  EventStatusFilter.INTERVIEW_ABANDONED,
];

export const ALL_STATUSES = [
  EventStatusFilter.ALL,
  ...INTERVIEW_STATUSES,
  ...GRADING_STATUSES,
  ...TEST_STATUSES,
];

export const PHASE_STATUS_VISIBILITY: Record<EventPhase, EventStatusFilter[]> =
  {
    [EventPhase.Test]: [EventStatusFilter.ALL, ...TEST_STATUSES],

    [EventPhase.Grading]: [
      EventStatusFilter.ALL,
      ...GRADING_STATUSES,
      ...TEST_STATUSES,
    ],

    [EventPhase.Interview]: ALL_STATUSES,

    [EventPhase.Closed]: ALL_STATUSES,
  };
